import React from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { ChevronDown, Check } from "lucide-react";

/** V1.81 · Filtro de selección múltiple (PHR · CP · Barrio) con recuento. */
export default function MultiFilter({ label, options, selected, onChange, testid, width = "min-w-[160px]" }) {
  const toggle = (value) => {
    const next = selected.includes(value)
      ? selected.filter((v) => v !== value)
      : [...selected, value];
    onChange(next);
  };

  const text = selected.length === 0
    ? "Todos"
    : selected.length === 1
    ? selected[0]
    : `${selected.length} seleccionados`;

  return (
    <label className="text-xs font-semibold text-neutral-600" title={selected.join(" · ")}>
      {label}
      <Popover>
        <PopoverTrigger asChild>
          <button
            type="button"
            data-testid={testid}
            className={
              "mt-1 flex items-center justify-between gap-2 h-9 rounded-lg border bg-white px-2 text-sm font-normal " +
              width + " " +
              (selected.length > 0 ? "border-orange-400 text-neutral-900" : "border-neutral-200 text-neutral-500")
            }
          >
            <span className="truncate">{text}</span>
            <ChevronDown className="h-4 w-4 shrink-0 opacity-60" />
          </button>
        </PopoverTrigger>
        <PopoverContent align="start" className="w-64 p-1 max-h-72 overflow-y-auto">
          <button
            type="button"
            data-testid={`${testid}-clear`}
            onClick={() => onChange([])}
            className="w-full text-left px-2 py-1.5 rounded-md text-xs font-semibold hover:bg-neutral-100"
          >
            Todos
          </button>
          <div className="h-px bg-neutral-100 my-1" />
          {options.length === 0 && (
            <p className="px-2 py-2 text-xs text-neutral-400">Sin valores en esta lista.</p>
          )}
          {options.map(([value, count]) => {
            const on = selected.includes(value);
            return (
              <button
                key={value}
                type="button"
                data-testid={`${testid}-opt-${value}`}
                onClick={() => toggle(value)}
                className={
                  "w-full flex items-center gap-2 px-2 py-1.5 rounded-md text-xs text-left hover:bg-neutral-100 " +
                  (on ? "bg-orange-50" : "")
                }
              >
                <span className={
                  "h-4 w-4 rounded border flex items-center justify-center shrink-0 " +
                  (on ? "bg-orange-600 border-orange-600 text-white" : "border-neutral-300")
                }>
                  {on && <Check className="h-3 w-3" />}
                </span>
                <span className="truncate flex-1">{value}</span>
                <span className="text-[10px] text-neutral-400">{count}</span>
              </button>
            );
          })}
        </PopoverContent>
      </Popover>
    </label>
  );
}
